import React from 'react';
import { LayoutTemplate } from 'lucide-react';
import { HomeLayoutShell } from '../components/home/layout/HomeLayoutShell';

/**
 * 详情页内页——与首页同步的即梦式流式壳：
 * 顶栏由 AppNew 统一挂载、背景 #121212 与全站一致、内容壳复用 HomeLayoutShell，
 * 内容列对齐首页 828 列节奏（AgentInputBox / CanvasGallery 同列，替代原 max-w-4xl
 * 896px——不在首页 828/1156/1400 列体系中）。主体内容后续版本按设计稿完善。
 */
export const DetailPage: React.FC = () => {
  return (
    <div className="w-full min-h-screen pt-24 pb-16" style={{ backgroundColor: '#121212' }}>
      <HomeLayoutShell>
        <div className="w-full max-w-[828px] mx-auto">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center">
              <LayoutTemplate size={20} className="text-zinc-200" />
            </div>
            <h1 className="text-2xl font-semibold text-white">详情页</h1>
          </div>
          <div className="rounded-2xl bg-white/[0.03] border border-white/10 p-12 text-center">
            <p className="text-zinc-400">详情页模板展示、工作台快捷入口</p>
            <p className="text-sm text-zinc-600 mt-2">placeholder，后续版本完善</p>
          </div>
        </div>
      </HomeLayoutShell>
    </div>
  );
};
